import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, TrendingUp, Building2 } from 'lucide-react';
import { activeMandates } from '../data/mock';

export const ActiveMandates = () => {
  return (
    <div className="service-detail-page">
      {/* Breadcrumb */}
      <div className="breadcrumb-container">
        <Link to="/" className="breadcrumb-link">
          <ArrowLeft size={18} />
          Back to Home
        </Link>
        <span className="breadcrumb-separator">/</span>
        <span className="breadcrumb-current">Active Mandates</span>
      </div>

      {/* Hero Section */}
      <section className="service-detail-hero">
        <h1 className="service-detail-title">Active Mandates</h1>
        <p className="service-detail-subtitle">
          Current transaction advisory mandates across real estate and capital markets
        </p>
      </section>

      {/* Real Estate Pipeline */}
      <section className="service-detail-section">
        <div className="service-detail-content">
          <div className="mandate-section">
            <div className="mandate-icon">
              <Building2 size={40} />
            </div>
            <h2 className="mandate-section-title">Real Estate Pipeline</h2>
            <div className="pipeline-metric-huge">{activeMandates.realEstate.pipeline}</div>
            
            <div className="mandate-grid">
              {activeMandates.realEstate.mandates.map((mandate, idx) => (
                <div key={idx} className="mandate-card">
                  <div className="mandate-bullet">•</div>
                  <span className="mandate-text">{mandate}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Capital Advisory Pipeline */}
      <section className="service-detail-section alt-bg">
        <div className="service-detail-content">
          <div className="mandate-section">
            <div className="mandate-icon">
              <TrendingUp size={40} />
            </div>
            <h2 className="mandate-section-title">Capital Advisory Pipeline</h2>
            <div className="pipeline-metric-huge">{activeMandates.capitalAdvisory.pipeline}</div>
            
            <div className="mandate-grid">
              {activeMandates.capitalAdvisory.mandates.map((mandate, idx) => (
                <div key={idx} className="mandate-card">
                  <div className="mandate-bullet">•</div>
                  <span className="mandate-text">{mandate}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Confidential Note */}
      <section className="service-detail-section">
        <div className="service-detail-content">
          <div className="confidential-box">
            <h3 className="confidential-title">Confidential Mandates</h3>
            <p className="confidential-text">
              HSNL Advisory works on select confidential mandates with developers, institutional investors and family offices across India and global markets.
            </p>
            <div className="confidential-metric">
              <div className="confidential-label">Typical Mandate Size</div>
              <div className="confidential-value">USD 10 Million+</div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="service-detail-section alt-bg">
        <div className="service-detail-content">
          <div className="service-cta-box">
            <h2 className="cta-title">Discuss Transaction Opportunities</h2>
            <p className="cta-text">
              Connect with our advisory team to explore current mandates and investment opportunities.
            </p>
            <Link to="/#contact" className="btn-primary">
              Initiate Discussion
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};
